import FoodApi from "../../data/FoodApi"
import Button from "../../gui/Button/Button"
import LogoutIcon from "../../gui/Icons/LogoutIcon"
import { useAuth } from "../../gui/Login/AuthProvider"
import { useLogin } from "../../gui/Login/LoginProvider"
import LoginButton from "../LoginButton"

function Profile(){
    const {logout} = useLogin()
    return <div className="keyval">
        <label>Name</label>
        <div>{FoodApi.i.name}</div>
            <Button variant="outlined" size="medium" onClick={logout}><LogoutIcon/>Logout</Button> :
    </div>
}
export default function Settings(){
    const {isLoggedIn} = useAuth()
    return <div id="settings">
        {isLoggedIn ? <Profile/> : <LoginButton/>}
    </div>
}